/* CAUTION: When using the generators, this file is modified in some places.
 *          This is done via AST traversal - Some of your formatting may be lost
 *          in the process - no functionality should be broken though.
 *          This modifications only run once when the generator is invoked - if
 *          you edit them, they are not updated again.
 */
// TODO: MB-4613 Rename App.js to AppContainer.js; and MainComponent.js to AppComponent.js
import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { requestConfig, receiveConfigAction } from '../app/config/ConfigActions';
import { getPendingApprovalsCount } from '../app/approvals/actions/ApprovalsActions';
import actions from '../app/core/actions';
import { canAccessApprovals } from '../app/services/user-permission/UserPermissionService';
import Thirdparty from '../thirdparty/Thirdparty';
import AnalyticsClient from '../clients/AnalyticsClient';

class App extends Component {
  UNSAFE_componentWillMount() {
    this.props.coreActions.requestConfig(this.props.runtimeConfig.api).then((config) => {
      if (canAccessApprovals(config.permissions)) {
        this.props.coreActions.getPendingApprovalsCount(this.props.runtimeConfig.api);
      }
    });
    this.props.coreActions.cartGetRequest(this.props.runtimeConfig.api);
  }

  componentDidMount() {
    Thirdparty.injectScripts();

    if (!this.isRedirect()) {
      AnalyticsClient.pushAdditionalData();
      AnalyticsClient.trackPageView(this.props.location.pathname);
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.isRedirect() && prevProps.location.pathname !== this.props.location.pathname) {
      AnalyticsClient.trackPageView(this.props.location.pathname);
    }
  }

  isRedirect() {
    return this.props.location.pathname !== this.props.history.location.pathname;
  }

  render() {
    return this.props.render(this.props);
  }
}

App.propTypes = {
  coreActions: PropTypes.object.isRequired,
  route: PropTypes.shape({
    runtimeConfig: PropTypes.object.isRequired,
  }),
};

const mapStateToProps = (state) => ({
  config: state.config,
  menu: state.menu,
  toast: state.toast,
  notification: state.notification,
  sideNavigation: state.sideNavigation,
  cart: state.cart,
  overlay: state.overlay,
  approvals: state.approvals,
});

const mapDispatchToProps = (dispatch) => {
  const coreActions = {
    ...actions,
    requestConfig,
    receiveConfigAction,
    getPendingApprovalsCount,
  };

  return { coreActions: bindActionCreators(coreActions, dispatch) };
};

export default compose(
  withRouter, // withrouter needs to come first https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/withRouter.md#important-note
  connect(mapStateToProps, mapDispatchToProps),
)(App);
